import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import {
	API_URL,
	scroll,
	isFieldError,
	getValFromLS,
	setValToLS,
} from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Checkbox from "../components/Checkbox";
import Select from "../components/Select";
import Input from "../components/Input";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Steps from "./Steps";

const RegQuestions = () => {
	const [details, setDetails] = useState({});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();
	const formElement = useRef(null);

	useEffect(() => {
		const init = () => {
			if (getValFromLS("auth", true) && getValFromLS("order", true)) {
				const orderFromLS = JSON.parse(getValFromLS("order", true));
				const authFromLS = JSON.parse(getValFromLS("auth", true));
				setDetails({
					levelId: orderFromLS.level.id,
					...orderFromLS.billto,
					...orderFromLS.allocation,
					email: authFromLS.email,
				});
				setAlert({});
				scroll();
			} else {
				history.push("/registration");
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	const handleUpdate = (name, value) => {
		if (name === "same" && value) {
			for (let n = 0; n < formElement.current.length; n++) {
				if (formElement.current[n].name === "prefix") {
					const val = details.prefix || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, prefix: val }));
				} else if (formElement.current[n].name === "fname") {
					const val = details.fname || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, fname: val }));
				} else if (formElement.current[n].name === "lname") {
					const val = details.lname || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, lname: val }));
				} else if (formElement.current[n].name === "title") {
					const val = details.title || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, title: val }));
				} else if (formElement.current[n].name === "organization") {
					const val = details.organization || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, organization: val }));
				} else if (formElement.current[n].name === "email") {
					const val = details.email || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, email: val }));
				} else if (formElement.current[n].name === "businessAddress") {
					const val = details.address || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, businessAddress: val }));
				} else if (formElement.current[n].name === "businessAddress2") {
					const val = details.address2 || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, businessAddress2: val }));
				} else if (formElement.current[n].name === "businessCity") {
					const val = details.city || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, businessCity: val }));
				} else if (formElement.current[n].name === "businessSt") {
					const val = details.st || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, businessSt: val }));
				} else if (formElement.current[n].name === "businessZip") {
					const val = details.zip || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, businessZip: val }));
				} else if (formElement.current[n].name === "businessCountry") {
					const val = details.country || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, businessCountry: val }));
				}
			}
		} else if (name === "same2" && value) {
			for (let n = 0; n < formElement.current.length; n++) {
				if (formElement.current[n].name === "emailingFname") {
					const val = names.fname || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, emailingFname: val }));
				} else if (formElement.current[n].name === "emailingLname") {
					const val = names.lname || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, emailingLname: val }));
				} else if (formElement.current[n].name === "emailingEmail") {
					const val = names.email || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, emailingEmail: val }));
				} else if (formElement.current[n].name === "emailingPhone") {
					const val = names.phone || "";
					formElement.current[n].value = val;
					setNames((names) => ({ ...names, emailingPhone: val }));
				}
			}
		}
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/registrationQuestions`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "same" || key === "same2") {
			} else if (key === "homeIntl") {
				data.append("homeIntl", names.homeIntl ? "1" : "0");
			} else {
				data.append(key, value);
			}
		});
		data.append("levelId", details.levelId);
		data.append("allocationGolf", details.golf);
		data.append("allocationSporting", details.sporting);
		data.append("allocationWelcome", details.welcome);
		data.append("allocationGift", details.gift);
		data.append("auth", getValFromLS("auth", true));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				let authFromLS = JSON.parse(getValFromLS("auth", true));
				authFromLS.status = json.status;
				authFromLS.fname = json.fname;
				authFromLS.email = json.email;
				setValToLS("auth", JSON.stringify(authFromLS), true);

				history.push("/registration/payment");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="Sponsor Registration" />
						<div className="blocktext step">
							<h1 style={{ marginBottom: "0" }}>5</h1>
							<div>
								<p>
									Please answer the following questions, so we have complete
									contact information for your registration. If you have any
									questions, please email{" "}
									<a href="mailto:ValeroBFC@valero.com">ValeroBFC@valero.com</a>
									.
								</p>
							</div>
						</div>

						<h3 style={{ marginTop: "25px", marginBottom: "25px" }}>
							Answer Questions
						</h3>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<h4
								style={{
									marginTop: "0",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Main Contact
							</h4>

							{!names.same && (
								<div className="form-group checkbox" style={{ marginTop: "0" }}>
									<Checkbox
										name="same"
										label="Check if main contact name/address is the same as bill to entered previously"
										checked={false}
										click={handleUpdate}
									/>
								</div>
							)}

							<div className="form-group">
								<Select
									name="prefix"
									label="Prefix"
									reqd={true}
									value={""}
									options={[
										{ id: "", name: "--" },
										{ id: "Mr.", name: "Mr." },
										{ id: "Mrs.", name: "Mrs." },
										{ id: "Ms.", name: "Ms." },
										{ id: "Dr.", name: "Dr." },
										{ id: "Other", name: "Other" },
									]}
									update={handleUpdate}
									error={isFieldError(errors, "prefix")}
								/>
								<div className="empty" />
							</div>

							<div className="form-group">
								<Input
									name="fname"
									label="First Name"
									reqd={true}
									value={names.fname || ""}
									autocomplete="given-name"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="lname"
									label="Last Name"
									reqd={true}
									value={names.lname || ""}
									autocomplete="family-name"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group">
								<Input
									name="title"
									label="Title"
									reqd={true}
									value={names.title || ""}
									autocomplete="organization-title"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="organization"
									label="Organization"
									reqd={true}
									value={names.organization || ""}
									autocomplete="organization"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group">
								<Input
									name="email"
									label="Email"
									reqd={true}
									value={names.email || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="phone"
									label="Phone"
									reqd={true}
									value={names.phone || ""}
									autocomplete="tel"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<h4
								style={{
									marginTop: "15px",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Business Shipping Address
							</h4>

							<div className="form-group">
								<Input
									name="businessAddress"
									label="Address"
									reqd={true}
									value={names.businessAddress || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="businessAddress2"
									label="Address 2"
									reqd={false}
									value={names.businessAddress2 || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group three">
								<Input
									name="businessCity"
									label="City"
									reqd={true}
									value={names.businessCity || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="businessSt"
									label="State (2-letter)"
									reqd={details.addressType === "intl" ? false : true}
									value={names.businessSt || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
								<Input
									name="businessZip"
									label="Zip Code"
									reqd={true}
									value={names.businessZip || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group">
								<Input
									name="businessCountry"
									label="Country Code (2-letter)"
									reqd={true}
									value={names.businessCountry || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
								<div className="empty" />
							</div>

							<h4
								style={{
									marginTop: "15px",
									lineHeight: "22px",
									marginBottom: "10px",
									fontSize: "1.1rem",
								}}
							>
								Home Shipping Address
							</h4>

							<div
								className="form-group checkbox"
								style={{ marginTop: "10px" }}
							>
								<Checkbox
									name="homeIntl"
									label="Check if your home address is International (not US or CA)"
									checked={false}
									click={handleUpdate}
								/>
							</div>

							<div className="form-group one">
								<Input
									name="homeAddress"
									label="Address"
									reqd={true}
									value={names.homeAddress || ""}
									autocomplete="street-address"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group three">
								<Input
									name="homeCity"
									label="City"
									reqd={true}
									value={names.homeCity || ""}
									autocomplete="address-level2"
									update={handleUpdate}
									errors={errors}
								/>

								{!names.homeIntl && (
									<Input
										name="homeSt"
										label="State (2-letter)"
										reqd={true}
										value={names.homeSt || ""}
										autocomplete="address-level1"
										update={handleUpdate}
										errors={errors}
									/>
								)}

								<Input
									name="homeZip"
									label="Zip Code"
									reqd={true}
									value={names.homeZip || ""}
									autocomplete="postal-code"
									update={handleUpdate}
									errors={errors}
								/>

								{names.homeIntl && (
									<Input
										name="homeCountry"
										label="Country Code (2-letter)"
										reqd={true}
										value={names.homeCountry || ""}
										autocomplete="cuntry"
										update={handleUpdate}
										errors={errors}
									/>
								)}
							</div>

							<h4
								style={{
									marginTop: "25px",
									lineHeight: "22px",
									marginBottom: "10px",
								}}
							>
								Please provide the <b>Contact Information</b> of the person who
								will be responsible for emailing the digital Valero Texas Open
								tickets to your BFC Attendee Guests:
							</h4>

							{!names.same2 && (
								<div
									className="form-group checkbox"
									style={{ marginTop: "10px" }}
								>
									<Checkbox
										name="same2"
										label="Check if above contact is also responsible for emailing tickets to guests"
										checked={false}
										click={handleUpdate}
									/>
								</div>
							)}

							<div className="form-group">
								<Input
									name="emailingFname"
									label="First Name"
									reqd={true}
									value={names.emailingFname || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>

								<Input
									name="emailingLname"
									label="Last Name"
									reqd={true}
									value={names.emailingLname || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="form-group">
								<Input
									name="emailingEmail"
									label="Email Address"
									reqd={true}
									value={names.emailingEmail || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>

								<Input
									name="emailingPhone"
									label="Phone Number"
									reqd={true}
									value={names.emailingPhone || ""}
									autocomplete="off"
									update={handleUpdate}
									errors={errors}
								/>
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Submit Questions & Continue" />
								</div>
							</div>
						</form>

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Steps on={5} user={JSON.parse(getValFromLS("auth", true))} />
					</div>
				</>
			)}
		</>
	);
};

export default RegQuestions;
